import React from "react";

const Button = ({ icon, innerText, width, onclick }) => {
  return (
    <button
      className={`${
        icon ? "flex justify-center gap-2 items-center" : ""
      } ${width} h-[44px] bg-sidenavActive rounded text-white font-Lato font-bold`}
      onClick={onclick}
    >
      <span>{icon}</span>
      <div>{innerText}</div>
    </button>
  );
};

export default Button;
